export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 3